import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import type {
	MiddlewareDefinition,
	MiddlewareOptions,
} from 'instantsearch.js/es/types/middleware'
import { UiState } from 'instantsearch.js/es/types/ui-state'
import { useEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'

const InsightsMiddleware = ({ user }: { user: User }): JSX.Element => {
	const { addMiddlewares } = useInstantSearch()

	useEffect(() => {
		if (!user) return
		const middleware = createInsightsMiddleware({
			insightsClient: window.aa,
			insightsInitParams: {
				useCookie: true,
			},
		})

		const insightsMiddleware = (
			options: MiddlewareOptions
		): MiddlewareDefinition<UiState> => {
			const definition = middleware(options) as MiddlewareDefinition<UiState>

			if (!('unsubscribe' in definition) || !definition.unsubscribe) {
				return definition
			}

			return {
				...definition,
				unsubscribe: () => {
					const { instantSearchInstance } = options
					const originalScheduleSearch = instantSearchInstance.scheduleSearch
					const blockScheduleSearch = Object.assign(() => undefined, {
						cancel: () => undefined,
					}) as typeof instantSearchInstance.scheduleSearch
					instantSearchInstance.scheduleSearch = blockScheduleSearch

					try {
						definition.unsubscribe()
					} finally {
						instantSearchInstance.scheduleSearch = originalScheduleSearch
					}
				},
			}
		}

		return addMiddlewares(insightsMiddleware)
	}, [addMiddlewares, user])

	return null
}

export default InsightsMiddleware
